<template>
	<div class="detail app-nav-wrap">
		<nav-bar :returnFunc="returnFunc" return-name="帮我找货" current-name="需求详情" />

		<div class="app-nav-content">
			<div class="card" v-if="data">
				<p><i>产品名称：</i>{{ data.product_name }}</p>
				<p><i>需求内容：</i><span class="remark">{{ data.remark }}</span></p>
				<p><i>图片数量：</i>{{ data.image_count }}</p>
				<p><i>状态：</i><span class="status">{{ data.statusText }}</span></p>
				<p><i>提交时间：</i>{{ data.ctimeText }}</p>
				<p><i>回复内容：</i><span class="comment">{{ data.comment || '暂无回复' }}</span></p>

				<div class="imgs" v-if="data.images && data.images.length">
					<p class="imgTitle">图片</p>
					<div class="imgGrid">
						<van-image v-for="(img, index) in data.images" :key="img.id" :src="img.url" fit="cover"
							class="img" @click="preview(index)" />

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import NavBar from '@/components/NavBar.vue';
	import CommonService from '@/io/common.js';

	export default {
		name: 'HelpFindGoodsDetail',
		components: {
			NavBar
		},
		data() {
			return {
				data: null,
			};
		},
		mounted() {
			this.initPage();
		},
		methods: {
			returnFunc() {
				this.$router.push({
					path: '/helpFindFood'
				});
			},
			initPage() {
				const id = this.$route.params.id || this.$route.query.id;
				if (!id) return;

				this.$toast.loading({
					message: '加载中...',
					duration: 0
				});
				CommonService.helpFindGoodsDetail(id)
					.then(res => {
						const d = res.data || {};
						d.comment = d.comment || '';
						d.statusText = this.statusText(d.status);
						d.ctimeText = this.formatTime(d.ctime);
						d.images = (d.images || []).map(it => ({
							...it,
							url: this.fullImg(it.url),
						}));
						this.data = d;
					})
					.finally(() => {
						this.$toast.clear();
					});
			},
			statusText(s) {
				const n = parseInt(s, 10);
				if (n === 0) return '待处理';
				if (n === 1) return '已联系';
				if (n === 2) return '已完成';
				if (n === 9) return '已关闭';
				return '未知';
			},
			formatTime(ts) {
				const t = parseInt(ts, 10);
				if (!t) return '';
				const d = new Date(t * 1000);
				const pad = v => (v < 10 ? `0${v}` : `${v}`);
				return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
			},
			fullImg(u) {
			  if (!u) return '';
			  if (/^https?:\/\//i.test(u)) return u;
			
			  const base = process.env.VUE_APP_IMAGE_URL || '';
			  if (!base) return u;
			
			  if (base.endsWith('/') || u.startsWith('/')) return `${base}${u}`;
			  return `${base}/${u}`;
			},

			preview(index) {
			  if (!this.data || !this.data.images || !this.data.images.length) return;
			
			  const urls = this.data.images.map(it => it.url);
			  const current = urls[index] || urls[0];
			
			  // wx 已经全局引入的话，直接用
			  if (window.wx && window.wx.previewImage) {
			    window.wx.previewImage({
			      current,
			      urls
			    });
			  }
			},

		},
	};
</script>

<style lang="less" scoped>
	@import '../assets/styles/tools.less';

	.detail {
		background-color: #F6F7F9;
		.iosBottom;

		.card {
			background-color: #FFFFFF;
			margin: 28 * @r 44 * @r;
			padding: 40 * @r 54 * @r;
			border-radius: 16 * @r;

			p {
				font-size: 26 * @r;
				display: flex;

				&+p {
					margin-top: 18 * @r;
				}

				i {
					width: 130 * @r;
				}

				.remark {
					flex: 1;
				}

				.status {
					color: #FDAB02;
				}

				.comment {
					flex: 1;
					color: #2B2F36;
					white-space: pre-wrap;
					word-break: break-all;
				}

			}

			.imgs {
				margin-top: 26 * @r;

				.imgTitle {
					font-size: 28 * @r;
					font-weight: bold;
					margin-bottom: 18 * @r;
				}

				.imgGrid {
					display: flex;
					flex-wrap: wrap;
					gap: 14 * @r;
				}

				/deep/ .img {
					width: calc((100% - 28 * @r) / 3); // 3列：两条 gap
					height: calc((100% - 28 * @r) / 3); // 让方块更接近正方形（也可写固定高度）
					aspect-ratio: 1 / 1; // 现代浏览器支持；不支持也有 height 兜底
					border-radius: 12 * @r;
					overflow: hidden;
				}

			}
		}
	}
</style>